import { EnvelopeIcon } from '@heroicons/react/24/outline';

export interface SubscribeAlertButtonProps {
  label: string;
  onClick: () => void;
}

/**
 * SubscribeAlertButton
 *
 * Text-link "follow entity" trigger rendered inside the centered editorial
 * card of `HeroHeaderText` (after the description). Purely presentational: the
 * subscribe logic lives in the entity-specific action slots that own the modal.
 *
 * Design (client request): plain primary-900 text link — no border, no pill.
 * A leading envelope icon precedes the label; underline on hover, centered
 * under the description.
 */
export const SubscribeAlertButton = ({
  label,
  onClick,
}: SubscribeAlertButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mx-auto mt-4 flex items-center gap-2 text-sm font-medium text-primary-900 underline-offset-4 transition-colors hover:underline"
    >
      <EnvelopeIcon className="size-4 shrink-0" aria-hidden="true" />
      {label}
    </button>
  );
};
